import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
    },
  },
});

/**
 * The desk's freshness (review AD-WR-04). The app-wide hour suits the
 * reference lists (venues, tags, cities), not the desk: new editor output,
 * another curator's decisions and paste results land between visits, and
 * the badges already re-read desk_counts every 60 s. Every desk key starts
 * with 'desk' (the prefix the decisions invalidate), so one prefix default
 * covers the queue, the candidate, its raw item and siblings, tabOf and the
 * match target: always stale, so a focus or a remount re-reads them.
 */
export const DESK_QUERY_STALE_TIME = 0;

queryClient.setQueryDefaults(["desk"], {
  staleTime: DESK_QUERY_STALE_TIME,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
});

export { queryClient };
